<template>
  <el-dialog title="凤栖云服开票资料" width="880px" class="my-dialog-template" :visible.sync="visible" top="0">
    <el-tabs v-model="tabName" @tab-click="tabsClick" v-if="subCompanysList&&subCompanysList.length>1">
      <el-tab-pane :label="item.subCompanyName=='梧桐树保险经纪有限公司'?item.subCompanyName:item.subCompanyName.replace('梧桐树保险经纪有限公司','')" 
        :name="i+''" v-for="(item, i) in subCompanysList" :key="i">
      </el-tab-pane>
    </el-tabs>
    <div class="content-box" v-if="subCompanyName=='梧桐树保险经纪有限公司总部'">
      <div class="content-title">开票资料</div>
      <div class="row">名称：梧桐树保险经纪有限公司</div>
      <div class="row">税号：91440000796298438D</div>
      <div class="row">单位地址：武汉市江汉区王家墩中央商务区泛海国际SOHO城3,4,6栋6号楼单元5层3-5室、7层2-5室、25层1-4号房</div>
      <div class="row">电话：027-83668382</div>
      <div class="row">开户银行：上海浦东发展银行武汉分行营业部</div>
      <div class="row">银行账户：7016 0078 8011 0000 0129</div>
    </div>
    <div class="content-box" v-if="subCompanyName=='梧桐树保险经纪有限公司北京分公司'">
      <div class="content-title">开票资料</div>
      <div class="row">开票抬头：梧桐树保险经纪有限公司北京分公司</div>
      <div class="row">纳税人识别号：91110105MA7G98A09P</div>
      <div class="row">地 址：北京市朝阳区建国路93号院A座7层0903内01室</div>
      <div class="row">电 话：027-83668382</div>
      <div class="row">开户行：招商银行股份有限公司北京分行华贸中心支行</div>
      <div class="row">帐 号：110949114210606</div>
    </div>
    <div class="content-box" v-if="subCompanyName=='梧桐树保险经纪有限公司深圳分公司'">
      <div class="content-title">开票资料</div>
      <div class="row">开票抬头：梧桐树保险经纪有限公司深圳分公司</div>
      <div class="row">纳税人识别号：91440300MA5GTRUC1G</div>
      <div class="row">地 址：深圳市南山区粤海街道高新区社区白石路3609号深圳湾科技生态园二区9栋A2607</div>
      <div class="row">电 话：027-83668382</div>
      <div class="row">开户行：招商银行股份有限公司深圳生态园支行</div>
      <div class="row">帐 号：755958220710701</div>
    </div>
    <div class="content-box" v-if="subCompanyName=='梧桐树保险经纪有限公司广东分公司'">
      <div class="content-title">开票资料</div>
      <div class="row">开票抬头：梧桐树保险经纪有限公司广东分公司</div>
      <div class="row">纳税人识别号：91440101MA9YAFT04L</div>
      <div class="row">地 址：广州市天河区天河路518号801室A17房(仅限办公)</div>
      <div class="row">电 话：027-83668382</div>
      <div class="row">开户行：招商银行股份有限公司广州分行营业部</div>
      <div class="row">帐 号：120921374910201</div>
    </div>
    <div class="content-box" v-if="subCompanyName=='梧桐树保险经纪有限公司江苏分公司'">
      <div class="content-title">开票资料</div>
      <div class="row">开票抬头：梧桐树保险经纪有限公司江苏分公司</div>
      <div class="row">纳税人识别号：91320104MA7L9BN04F</div>
      <div class="row">地 址：南京市鼓楼区中山北路8号2204室部分（门牌号2710室）</div>
      <div class="row">电 话：027-83668382</div>
      <div class="row">开户行：招商银行股份有限公司南京新街口支行</div>
      <div class="row">帐 号：125914347410106</div>
    </div>
    <div class="content-box" v-if="subCompanyName=='梧桐树保险经纪有限公司湖北分公司'">
      <div class="content-title">开票资料</div>
      <div class="row">开票抬头：梧桐树保险经纪有限公司湖北分公司</div>
      <div class="row">纳税人识别号：91420103MA4KUMYQ5F</div>
      <div class="row">地 址：武汉市江汉区王家墩中央商务区泛海国际SOHO城3,4,6栋6号楼单元7层1、6室</div>
      <div class="row">电 话：027-83777889</div>
      <div class="row">开户行：中国建设银行股份有限公司武汉中央商务区支行</div>
      <div class="row">帐 号：42050110224800000393</div>
    </div>
    <div class="content-box" v-if="subCompanyName=='梧桐树保险经纪有限公司河北分公司'">
      <div class="content-title">开票资料</div>
      <div class="row">开票抬头：梧桐树保险经纪有限公司河北分公司</div>
      <div class="row">纳税人识别号：91130104MABQ19W47C</div>
      <div class="row">地 址：河北省石家庄市桥西区中山西路108号华润万象城02-1014</div>
      <div class="row">电 话：027-83668382</div>
      <div class="row">开户行：招商银行股份有限公司石家庄分行营业部</div>
      <div class="row">帐 号：311903240410701</div>
    </div>
    <div class="content-box" v-if="subCompanyName=='梧桐树保险经纪有限公司江西分公司'">
      <div class="content-title">开票资料</div>
      <div class="row">开票抬头：梧桐树保险经纪有限公司江西分公司</div>
      <div class="row">纳税人识别号：91360125MABU10E25J</div>
      <div class="row">地 址：江西省南昌市红谷滩区红谷中大道998号绿地中央广场双子塔A1#办公楼3608室</div>
      <div class="row">电 话：027-83668382</div>
      <div class="row">开户行：中国工商银行股份有限公司南昌豫章支行</div>
      <div class="row">帐 号：1502003909000068965</div>
    </div>
    <div class="content-box" v-if="subCompanyName=='梧桐树保险经纪有限公司四川分公司'">
      <div class="content-title">开票资料</div>
      <div class="row">开票抬头：梧桐树保险经纪有限公司四川分公司</div>
      <div class="row">纳税人识别号：91510105MABM6J4C57</div>
      <div class="row">地 址：成都市青羊区二环路西二段12号1栋9层1号909室 </div>
      <div class="row">电 话：027-83668382</div>
      <div class="row">开户行：招商银行股份有限公司成都分行清江支行</div>
      <div class="row">帐 号：128914020910101</div>
    </div>
    <div class="info-box">
      <div class="info-title">开票提示</div>
      <div class="row" style="margin-bottom:6px;">大类选择：必须选择 “生产生活服务” 大类。</div>
      <div class="row" style="margin-bottom:6px;">路径选择：依次选择 “商务辅助服务 → 其他经纪代理服务”。</div>
      <div class="row" style="margin-bottom:6px;">税收分类编码：固定为 3040802990000000000，不得变更。</div>
      <div class="row" style="margin-bottom:16px;">项目名称：请根据实际业务性质准确填写，如经纪代理服务费/手续费/服务费。</div>
      <div class="info-title">开票类目</div>
      <div class="row" style="margin-bottom:6px;">A：全国经代公司开票类目：“生产生活服务*经纪代理服务费/生产生活服务*经纪代理手续费”；</div>
      <div class="row" >B：区域经代公司开票类目：</div>
      <p>（1）如开展线上引流业务，需开具：“生产生活服务*服务费”；</p>
      <p style="margin-bottom:6px;">（2）如只开展线下经代业务，则开具：“生产生活服务*经纪代理服务费/生产生活服务*经纪代理手续费”；</p>
      <div class="row" style="margin-bottom:6px;">C：引流机构开票类目：“生产生活服务*服务费”</div>
    </div>
    <img src="@static/images/invoice.png" alt="">
    <div class="content-box">
      <div class="content-title">邮寄信息</div>
      <div class="row">收件信息：武汉市江汉区泛海国际SOHO城第6栋7楼</div>
      <div class="row">组织：财务机构组 </div>
      <div class="row">电话：027-83868566</div>
      <div class="row">邮编：430000</div>
    </div>
  </el-dialog>
</template>
<script>
import { pageTool } from '@/api/mixins'
export default {
  mixins: [pageTool],
  components: {},
  props:{
    subCompanysList:null
  },
  data: () => ({
    tableH:document.body.clientHeight - 400,
    visible:false,
    subCompanyName:'',//当前选中的subCompanyName
    tabName:'0',
  }),
  created() {},
  methods: {
    open(){
      this.tabName = '0';
      this.visible=true;
      this.subCompanyName = this.subCompanysList[0]?.subCompanyName;
    },
    tabsClick(data){
      this.subCompanyName = this.subCompanysList[data.index]?.subCompanyName;
    }
  },
}
</script>
<style lang='scss' scoped>
.my-dialog-template /deep/ {
  display: flex;
  align-items: center;
  .el-dialog {
    margin-top: 0;
    margin-bottom: 0;
  }
  .el-dialog__body {
    padding-top: 10px;
    max-height: 80vh;
    overflow-y: auto;
  }
  img {
    margin-bottom: 15px;
  }
  .el-tabs__content {
    padding-top: 15px;
  }
  .content-box {
    margin-bottom: 10px;
    .content-title {
      font-size: 16px;
      color: #333;
      font-weight: bold;
      margin-bottom: 10px;
      padding-left: 10px;
      position: relative;
      &::before {
        content: "";
        width: 3px;
        height: 14px;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        background: #F47900;
        border-radius: 6px;
      }
    }
    .row {
      font-size: 14px;
      color: #666;
      margin-bottom: 7px;
    }
  }
  .info-box {
    background: #F8F7F7;
    padding: 15px;
    border-radius: 4px;
    margin-bottom: 30px;
    .info-title {
      font-size: 14px;
      color: #666;
      font-weight: bold;
      margin-bottom: 10px;
    }
    p,
    .row {
      font-size: 12px;
      color: #666;
    }
    p {
      padding-left: 1em;
    }
    .text {
      font-size: 12px;
      color: #666;
      font-weight: bold;
      margin-top: 8px;
    }
  }
  
}

</style>